module.exports = __webpack_public_path__ + "static/img/computer_256.d304afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/computer_256.png
// module id = 1A9U
// module chunks = 0